<template>
  <div class="footerContain">
    <div class="pOne">
      Copyright(c) 匠芯株式会社 
      <span>2023 Co.,Ltd. All rights Reserved.| </span>
      <span @click="goPolicy" class="cursor"> 個人情報保護方針 |</span>
      <span @click="goAccess" class="cursor"> お問い合せ </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomFooter',
  methods:{
    goAccess(){
      this.$router.push({path:'/access'})
    },
    goPolicy(){
      this.$router.push({path:'/policy'})
    }
  }

}
</script>

<style scoped>
.footerContain{
  background: #eaeaea;
  padding: 15px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left:0;
  box-sizing: border-box;
}
.pOne{
  font-size: 10px;
  color: #333;
}
</style>